import React from 'react';

function MenuIcon(props) {
  return (
    <svg
      width={38}
      height={39}
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={11.4} cy={20.7} r={1.9} fill="white" />
      <circle cx={18.9996} cy={20.7} r={1.9} fill="white" />
      <circle cx={26.6002} cy={20.7} r={1.9} fill="white" />
    </svg>
  );
}

export default MenuIcon;
